<template>
  <b-modal
      ref="add-tag-modal"
      size="lg"
      :title="$t(title.toString())"
  >
    <b-form>
      <b-form-group
          :label="$t('tag.form.name')" label-for="input-2">
        <b-form-input
            id="input-2"
            v-model="form.name"
            :state="!$v.form.name.$dirty ? null :(!$v.form.name.$error)"
            required
        ></b-form-input>
      </b-form-group>

    </b-form>
    <template #modal-footer>
      <div class="w-100">
        <div class="buttons float-right">
          <b-button type="button" variant="secondary" class="mr-1" @click="hideModal()">{{$t('btn.cancel')}}</b-button>
          <b-button variant="primary" :disabled="busy" @click="submit()">
            <div v-if="busy">
              <b-spinner small type="grow"></b-spinner>
              {{ $t('btn.state.saving') }}
            </div>
            <div v-else>
              {{ $t('btn.save') }}
            </div>
          </b-button>
        </div>
      </div>
    </template>
  </b-modal>
</template>

<script>
import {required} from "vuelidate/lib/validators";

export default {
  data() {
    return {
      title: null,
      busy: false,
      groups: [],
      serverError: null,
      form: {
        name: null,
      },
    }
  },
  validations: {
    form: {
      name: {
        required
      }
    }
  },
  mounted() {
    this.openModal();
  },
  computed: {
  },
  methods: {
    submit() {

    },
    openModal() {
      this.$refs['add-tag-modal'].show();
    },
    hideModal() {
      this.$refs['add-tag-modal'].hide();
    },
    isRestricted(e) {
      e = (e) ? e : window.event;
      let charCode = (e.which) ? e.which : e.keyCode;
      // 0-9 and . are allowed
      if (charCode !== 44 && charCode !== 46 && (charCode < 48 || charCode > 57)) {
        e.preventDefault();
      } else {
        return true;
      }
    }
  }
}
</script>
